// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nhtml {\n  margin: 0;\n  padding: 0;\n}\nbody {\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  font-family: \"Open Sans\", sans-serif;\n  color: #232321;\n  background: #fff !important;\n}\nhtml,\nbody,\n#app {\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: rgb(31, 39, 57);\n}\n#app {\n  overflow: auto;\n}\n* {\n  margin: 0;\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
